import axios from 'axios';
import { VUE_APP_GCN_SERVICES } from '@/constants';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/security`;

class SecurityService {
  public async isUsuarioLogado() {
    return axios.get<undefined>(`${BASE_URL}/check/login`);
  }
}

export default new SecurityService();
